// Revisado: 2025-12-18 I18n Updated
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '../../routes';
import { useAuth } from '../../context/AuthContext';
import { useTranslation } from 'react-i18next';

const SearchSupport = ({
    searchTerm,
    onSearchChange,
    selectedType,
    onTypeChange,
    selectedRarity,
    onRarityChange
}) => {
    const { t } = useTranslation();
    const types = ['Speed', 'Stamina', 'Power', 'Guts', 'Wit', 'Pal', 'Group'];
    const rarities = ['SSR', 'SR', 'R'];

    // Auth for Admin check
    const { isAdmin } = useAuth();
    const navigate = useNavigate();

    return (
        <div className="mb-6 flex flex-col gap-2">

            {/* Admin Actions (Above Search) */}
            {isAdmin() && (
                <div className="flex justify-end">
                    <button
                        onClick={() => navigate(`${ROUTES.CHARACTERS_SUPPORT}/edit`)}
                        className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-lg transition-colors font-semibold shadow-md text-sm"
                    >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                        </svg>
                        {t('SearchSupport.add_button')}
                    </button>
                </div>
            )}

            <div className="bg-white p-4 rounded-xl shadow-sm flex flex-col gap-4">
                <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
                    {/* Text Search */}
                    <div className="relative w-full md:w-1/3">
                        <input
                            type="text"
                            placeholder={t('SearchSupport.search_placeholder')}
                            value={searchTerm}
                            onChange={(e) => onSearchChange(e.target.value)}
                            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all dark:bg-gray-700 dark:border-gray-600 dark:text-gray-100"
                        />
                        <svg
                            className="w-5 h-5 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>

                    {/* Filters Container */}
                    <div className="flex flex-col md:flex-row gap-4 w-full md:w-auto">

                        {/* Rarity Filter */}
                        <div className="flex flex-wrap gap-2 justify-center md:justify-end items-center">
                            <span className="text-sm font-semibold text-gray-500 mr-1">{t('SearchSupport.filter_rarity')}</span>
                            <button
                                onClick={() => onRarityChange('All')}
                                className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${selectedRarity === 'All'
                                    ? 'bg-gray-800 text-white'
                                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                    }`}
                            >
                                {t('SearchSupport.filter_all')}
                            </button>
                            {rarities.map((rarity) => (
                                <button
                                    key={rarity}
                                    onClick={() => onRarityChange(rarity)}
                                    className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${selectedRarity === rarity
                                        ? rarity === 'SSR' ? 'bg-gradient-to-r from-yellow-400 to-yellow-600 text-white shadow-md' :
                                            rarity === 'SR' ? 'bg-gradient-to-r from-yellow-200 to-yellow-400 text-yellow-900' :
                                                'bg-gray-400 text-white'
                                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                        }`}
                                >
                                    {rarity}
                                </button>
                            ))}
                        </div>

                        <div className="w-px bg-gray-200 hidden md:block"></div>

                        {/* Type Filter */}
                        <div className="flex flex-wrap gap-2 justify-center md:justify-end items-center">
                            <span className="text-sm font-semibold text-gray-500 mr-1">{t('SearchSupport.filter_type')}</span>
                            <button
                                onClick={() => onTypeChange('All')}
                                className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${selectedType === 'All'
                                    ? 'bg-gray-800 text-white'
                                    : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                    }`}
                            >
                                {t('SearchSupport.filter_all')}
                            </button>
                            {types.map((type) => (
                                <button
                                    key={type}
                                    onClick={() => onTypeChange(type)}
                                    className={`px-3 py-1 rounded-full text-sm font-medium transition-colors ${selectedType === type
                                        ? 'bg-blue-600 text-white shadow-md'
                                        : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
                                        }`}
                                >
                                    {type}
                                </button>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SearchSupport;
